import { FoxRequestHeader } from "../domain/fox-request-header";

export const GetReservationRequest = function (reservationCode) {
  this.requestHeader = new FoxRequestHeader({ requestType: "GET" });
  this.reservationCode = reservationCode;
};
